import { z } from "zod";

/**
 * Breadcrumbs come from route `handle`s. React Router types handles as `unknown`, so they are
 * validated with a schema instead of cast.
 */
const crumbSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("static"), label: z.string() }),
  // Label is the project's name, resolved from the `:projectKey` param.
  z.object({ kind: z.literal("project") }),
  // Label is the task key from the `:taskKey` param.
  z.object({ kind: z.literal("task") }),
]);
const handleSchema = z.object({ crumb: crumbSchema });

export type Crumb = z.infer<typeof crumbSchema>;

export function crumb(label: string): { crumb: Crumb } {
  return { crumb: { kind: "static", label } };
}

export const projectCrumb: { crumb: Crumb } = { crumb: { kind: "project" } };

export const taskCrumb: { crumb: Crumb } = { crumb: { kind: "task" } };

export function getCrumb(handle: unknown): Crumb | undefined {
  const parsed = handleSchema.safeParse(handle);
  return parsed.success ? parsed.data.crumb : undefined;
}
